
class PaymentFeeTemplateSelectCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set title(text:string){
        this.nameLabel.text = text;
    }
}

// Popover to choose the payment fee template of a business license (CUSTOM when none).
// Selecting only reports the choice through the completion block: the owner confirms
// and applies, because picking a template replaces the license's fee rows.
class PaymentFeeTemplateSelectViewController extends MUIViewController
{
    static newInstance() : PaymentFeeTemplateSelectViewController {
        let vc = new PaymentFeeTemplateSelectViewController("payment-fee-template-select-view");
        vc.initWithResource("layout/payment_fee_templates/PaymentFeeTemplateSelectView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(320, 400);
    }

    selectedTemplate:PaymentFeeTemplate = null;
    completionTarget:any = null;
    completionBlock:any = null;

    private tableView:UITableView = null;
    private templates:PaymentFeeTemplate[] = [];

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);

        DBHelper.queryObjectsWithCompletion("PaymentFeeTemplate", [MIOSortDescriptor.sortDescriptorWithKey("name", true)], MIOPredicate.predicateWithFormat("deletedAt == null"), [], this, function(this:PaymentFeeTemplateSelectViewController, objects){
            this.templates = objects;
            if (this.viewIsLoaded) this.tableView.reloadData();
        });
    }

    numberOfSections(tableView:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.templates.length + 1;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("TemplateCell") as PaymentFeeTemplateSelectCell;

        let template = indexPath.row == 0 ? null : this.templates[indexPath.row - 1];
        cell.title = template != null ? template.name : MIOLocalizeString("CUSTOM", "CUSTOM");
        cell.accessoryType = (this.selectedTemplate == template) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;

        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let template = indexPath.row == 0 ? null : this.templates[indexPath.row - 1];

        if (this.completionBlock != null && this.completionTarget != null) this.completionBlock.call(this.completionTarget, template);
        this.dismissViewController(true);
    }
}
